import React from 'react';
import CustomNavbar from './CustomNavbar';
import ContactDrawer from './ContactDrawer';
import ButtonWithArrow from './ButtonWithArrow';

interface AppLayoutProps {
    children: React.ReactNode;
    onNavigate?: (page: 'home' | 'accent-detector' | 'video-generator') => void;
    isSmallScreen: boolean;
    contactOpen: boolean;
    setContactOpen: React.Dispatch<React.SetStateAction<boolean>>;
    showNavbar?: boolean;
    showFooter?: boolean;
    style?: React.CSSProperties;
}

const AppLayout: React.FC<AppLayoutProps> = ({
    children,
    onNavigate,
    isSmallScreen,
    contactOpen,
    setContactOpen,
    showNavbar = true,
    showFooter = true,
    style,
}) => {
    return (
        <div className="layoutShell" style={style}>
            {showNavbar && (
                <CustomNavbar
                    setContactOpen={setContactOpen}
                    isSmallScreen={isSmallScreen}
                    onNavigate={onNavigate}
                />
            )}

            <main className="layoutMain">{children}</main>

            {showFooter && (
                <footer className="Footer">
                    <div className="footerContent">
                        <a className="footerLink" href="mailto:andrei@astrostar.biz">
                            <i className="fa fa-envelope email"></i>
                            andrei@astrostar.biz
                        </a>
                        <div className={`footerContacts text-default ${isSmallScreen ? ' text-content-sm' : 'text-content-lg'}`}>
                            <div><i className="fa fa-phone"></i> Phone: +375 25 7527314</div>
                            <div><i className="fab fa-whatsapp fa-2x whatsapp"></i> WhatsApp: +48 888 663 869</div>
                        </div>
                    </div>
                </footer>
            )}

            <ContactDrawer
                open={contactOpen}
                onClose={() => setContactOpen(false)}
                onSubmit={(data) => {
                    console.log('contact submit', data);
                }}
            />
        </div>
    );
};

export default AppLayout;
